import { WALLET_UPDATE_WALLET_STORAGE_REQUEST } from 'wallet-manager';
import { eventBus } from '@atc/cai-event-bus';
const updateMyWalletInteractions = _ref => {
  let {
    types
  } = _ref;
  return payload => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;
    if (!payload.interactions?.isFetchingBudgetData) {
      eventBus.emit(WALLET_UPDATE_WALLET_STORAGE_REQUEST, {
        currentPaymentsInfo: {
          ...paymentsInfo
        },
        payload: {
          interactions: {
            ...paymentsInfo?.interactions,
            ...payload
          }
        }
      });
    }
    dispatch({
      type: types.UPDATE_MY_WALLET_INTERACTIONS,
      payload: {
        ...payload
      }
    });
  };
};
export default updateMyWalletInteractions;